import { render } from "./PriceCalculationModal.vue?vue&type=template&id=1f9ad23f"
import script from "./PriceCalculationModal.vue?vue&type=script&lang=js"
export * from "./PriceCalculationModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__